import React, { useEffect, useState } from "react";
import { injectIntl, InjectedIntlProps, FormattedMessage } from "@ai360/core/intl";

import { Section, SubSection, Tabs, Pane } from "~/core";
import { messages } from "../i18n-messages";
import { getReleaseNotes } from "~/login/selectors";
import "./about.css";
import "react-quill/dist/quill.snow.css";
import "../../core/components/text-editor/text-editor.css";
import { logFirebaseEvent } from "~/utils/firebase";
import { useAppSelector } from "~/store/hooks";

function About_(props: InjectedIntlProps) {
    const { formatMessage } = props.intl;
    const releaseNotesProps = useAppSelector(getReleaseNotes);

    const [selectedTabIdx, setSelectedTabIdx] = useState(0);
    useEffect(() => {
        logFirebaseEvent("about_version");
    }, []);

    const switchTabs = (idx: number) => {
        switch (idx) {
            case 0:
                logFirebaseEvent("about_version");
                break;
            case 1:
                logFirebaseEvent("about_release_notes");
                break;
        }
        setSelectedTabIdx(idx);
    };

    const buildStr = window.process_env.__BUILD_STR__.split("|");
    const releaseNotesPane = (
        <Pane
            key={1}
            label={<FormattedMessage {...messages.releaseNotes} />}
            testId="about-release-notes-pane"
        >
            <div className="ql-container ql-snow">
                <div className="ql-editor">
                    <div className="release-notes">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: releaseNotesProps,
                            }}
                        />
                    </div>
                </div>
            </div>
        </Pane>
    );
    const versionsPane = (
        <Pane
            key={0}
            label={<FormattedMessage {...messages.version} />}
            testId="about-version-pane"
        >
            <div className="build-version">
                <Section testId="about-build-version-section">
                    <SubSection testId="about-build-subsection">
                        <div className="sub-description-container">
                            {formatMessage(messages.build)}:{" "}
                            <span className="sub-description">{buildStr[0]}</span>
                        </div>
                    </SubSection>
                    <SubSection testId="about-date-subsection">
                        <div className="sub-description-container">
                            {formatMessage(messages.date)}:{" "}
                            <span className="sub-description">{buildStr[1]}</span>
                        </div>
                    </SubSection>
                </Section>
                {window.process_env.ENV_NAME !== "skyprod" && (
                    <SubSection testId="about-third-party-ref-subsection">
                        <div className="sub-description-container third-party-ref">
                            {formatMessage(messages.thirdPartyRef)}:
                            <div className="sub-description">
                                {formatMessage(messages.cropwise)}
                            </div>
                        </div>
                    </SubSection>
                )}
            </div>
        </Pane>
    );
    return (
        <div className="add-edit-panel">
            <div className="about">
                <Tabs
                    className="filter-tabs"
                    selected={selectedTabIdx}
                    onTabSelect={(idx) => switchTabs(idx)}
                    testId="about-tabs"
                >
                    {versionsPane}
                    {releaseNotesPane}
                </Tabs>
            </div>
        </div>
    );
}

export const About = injectIntl(About_);
